// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const burgerBtn = document.querySelector('[data-burgeropen]');
const burgerClose = document.querySelector('[data-burgerclose]');
const burgerMenu = document.querySelector('[data-burgermenu]');


(function(){

	if(document.querySelectorAll('.btn').length > 0){
		document.querySelectorAll('.btn').forEach( btn => {
			btn.setAttribute('data-text', btn.textContent);
			if(btn.querySelector('span') === null){
				let span = document.createElement('span');
				span.innerHTML = btn.innerHTML;
				btn.innerHTML = '';
				btn.appendChild(span);
			}
		})
	}

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

	//cms form animation
	if(document.querySelectorAll('.form-module__field').length > 0){
		document.querySelectorAll('.form-module__field').forEach( field => {
			if(field.querySelector('input')){
				field.querySelector('input').addEventListener('focus',() =>{field.classList.add('focused')})
			}
			if(field.querySelector('select')){
				field.querySelector('select').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
			if(field.querySelector('textarea')){
				field.querySelector('textarea').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
			const guestInput = field.querySelector("input[name=number_of_guests]");
			if (guestInput) {
				guestInput.setAttribute("max", 12);
			}
		});
	}

	//burger menu 
	if(burgerMenu) {
		burgerBtn.addEventListener('click', (e) => {
			e.preventDefault();
			burgerMenu.classList.add('open');
		})
		
		burgerClose.addEventListener('click', (e) => {
			e.preventDefault();
			burgerMenu.classList.remove('open');
		})
	}
	

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.add('scroll');
		}
		
	} else {
		if(document.getElementById('header').classList.contains('scroll')){
			document.getElementById('header').classList.remove('scroll');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}